module.exports = __webpack_public_path__ + "static/media/fever.942e9e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/fever.png
// module id = 402
// module chunks = 0